import React, { useMemo } from 'react';
import { useOrgData } from '../../contexts/OrgDataContext';
import { useLocale } from '../../contexts/LocaleContext';
import './StatsPanel.css';

export const StatsPanel: React.FC = () => {
  const { employees, getFilteredEmployees, maxLevel } = useOrgData();
  const { t } = useLocale();

  const totalEmployees = employees.length;
  const filteredEmployees = getFilteredEmployees();

  // Calculate visible count based on depth level
  const visibleCount = useMemo(() => {
    // Build level map
    const levelMap = new Map<string, number>();
    const root = filteredEmployees.find(e => !e.pid);
    if (root) {
      levelMap.set(root.id, 1);
    }

    // BFS to calculate levels
    let changed = true;
    while (changed) {
      changed = false;
      for (const emp of filteredEmployees) {
        if (emp.pid && levelMap.has(emp.pid) && !levelMap.has(emp.id)) {
          levelMap.set(emp.id, levelMap.get(emp.pid)! + 1);
          changed = true;
        }
      }
    }

    // Count employees at or below maxLevel
    if (maxLevel >= 10) {
      return filteredEmployees.length;
    }

    return filteredEmployees.filter(e => {
      const level = levelMap.get(e.id) || 1;
      return level <= maxLevel;
    }).length;
  }, [filteredEmployees, maxLevel]);

  return (
    <div className="stats-panel">
      <div className="stat-card">
        <div className="stat-value">{totalEmployees}</div>
        <div className="stat-label">{t('stats.totalEmployees')}</div>
      </div>
      <div className="stat-card">
        <div className="stat-value">{visibleCount}</div>
        <div className="stat-label">{t('stats.shown')}</div>
      </div>
    </div>
  );
};
